<template>
<div id="app">

    <div class="margin-center" style="min-width: 1220px;width: 100%;">
        <div v-for="(item, index) in parts" :key="index" style="height:164px;margin-bottom: 10px;">
            <el-image style="width:100%;height:100%;" :src="item.ImageUrl" fit="cover"></el-image>
        </div>
    </div>
    <div class="width bg-white margin-center flex flex-direction   backgroud margin-top-15 padding-t-b-15">

        <div v-for="(item, index) in dataList" :key="index" class="flex padding-15" style="height: 199px; overflow: hidden; position: relative;" @click="clickVideo(index)">
            <div class="backhover" style="width: 281px;height: 169px;" :style="{backgroundImage:'url('+item.courseUrl+')'}">
                <div>
                    <i class="subMask"></i>

                </div>
            </div>
            <div class="flex flex-direction flex-sub " style="margin-left:15px">
                <p class="font-color-333-red  font-weight  font-size-16" style="text-decoration: none;text-align: left;line-height: 50px;cursor: pointer;">{{item.title}}</p>
                <p class="text-line1 font-color-999 text-left font-size-12">主讲人：{{item.author}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 课时：{{item.videoSize}}</p>
                <p style="margin-top:5px;line-heigh:20px" class=" font-color-999 text-left font-size-12">{{item.courseDes}}</p>
            </div>
        </div>

    </div>
    <Bottom></Bottom>
</div>
</template>

<script>
export default {
    name: 'app',

    data() {
        return {
            show: true,
            clickOn: 2,
            parts: [],
            dataList: this.Common.listData,

        }
    },
    created() {
        this.getParts();
    },
    methods: {
        getParts() {
            var that = this;
            this.getRequest('api/v1/parts/', {
                CatalogId: 2993
            }).then(data => {
                if (data.IsSuccess) {
                    that.parts = data.Data;
                } else {
                    this.$message.error(data.Message)
                }
            })
        },
        clickVideo(index) {

            this.$router.push({
                name: 'make' + index,
                params: {
                    index: index
                }
            })

        },

    }
}
</script>

<style scoped>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    display: flex;
    flex-direction: column;
    justify-content: center;

}

body {
    background: #ffffff;
    padding: 0 0;
}

.backgroud {
    width: 1220px;

    background: #ffffff;
    box-shadow: 0px 3px 20px 0px #ececec;

}

.backhover {
    width: 280px;
    height: 168px;
    overflow: hidden;
  margin-top: -168px;
    background-size: cover;
    background-repeat: no-repeat
}

.backhover div {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.backhover .subMask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: .3;
    filter: alpha(opacity=30);
    z-index: 0
}

.backhover .playIcon {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 6;
    opacity: 0;
    margin: -30px 0 0 -30px;
    width: 60px;
    height: 60px;
    background: url(https://h5.cdn.bjadks.com/website/wsbgt-zt/999-linshi_szk/play-icon1.png) no-repeat;
    filter: alpha(opacity=0);
    -webkit-transition: all .3s ease-out;
    -moz-transition: all .3s ease-out;
    -ms-transition: all .3s ease-out;
    -o-transition: all .3s ease-out;
    transition: all .3s ease-out;
    -webkit-transform: scale(1.5);
    -moz-transform: scale(1.5);
    -ms-transform: scale(1.5);
    transform: scale(1.5)
}

.backhover div:hover .subMask {
    display: block;
    z-index: 5
}

.backhover div:hover .playIcon {
    z-index: 6;
    opacity: 1;
    filter: alpha(opacity=100);
    transform: scale(1);
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1)
}
</style>



// WEBPACK FOOTER //
// src/views/sizheng/sizheng.vue